// extracted by mini-css-extract-plugin
module.exports = {"departments":"fm-z","departmentHeading":"gm-z","departmentSection":"hm-z","departmentName":"im-z","departmentLink":"jm-z","expandIcon":"km-z"};